var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#11004D",
    d: "M21.884 15.298a29.39 29.39 0 01-.714 4.398C20.965 20.953 19.74 22 18.413 22h-1.634c-.918 0-1.633-.733-1.633-1.675V16.03c0-1.047-.817-1.884-1.838-1.884H10.96c-1.021 0-1.838.837-1.838 1.884v4.294c0 .942-.715 1.675-1.634 1.675h-1.94c-1.327 0-2.45-.942-2.756-2.304-.306-1.36-.572-2.663-.715-4.398-.181-2.2 0-4.293.102-5.654 0-.838.51-1.675 1.225-2.199l7.147-4.921c.409-.315.92-.524 1.43-.524.51 0 1.123.21 1.531.524l7.147 4.921c.715.524 1.225 1.361 1.225 2.199.102 1.361.2 3.455 0 5.654z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.838a67233e4e788b8d77166f1ff97bc0.svg";
export { ForwardRef as ReactComponent };